/**
 * Changes the teaser--vertical styles to horizontal in mobile view
 */

function teaserClassToggle() {
  if (window.innerWidth < 720) {
    var teasers = document.querySelectorAll('.teaser--vertical');

    if (teasers) {
      if ('NodeList' in window && !NodeList.prototype.forEach) {
        console.info('polyfill for IE11');
        NodeList.prototype.forEach = function (callback, thisArg) {
          thisArg = thisArg || window;
          for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
          }
        };
      }

      teasers.forEach(element => {
        element.classList.remove('teaser--vertical');
        element.classList.add('teaser--vertical-mobile');
      });

    }
  } else {
    var teasers = document.querySelectorAll('.teaser--vertical-mobile');

    if (teasers) {
      teasers.forEach(element => {
        element.classList.remove('teaser--vertical-mobile');
        element.classList.add('teaser--vertical');
      });
    }
  }
}
